export default __webpack_public_path__ + "static/media/web_screen_chat_ja.b352df69.png";